import { Injectable } from '@angular/core';
import { PhxContextService, PHOENIX_CONTEXTS } from '../../../services/phx-context-service';

@Injectable()
export class PhxOmnifilterContextService extends PhxContextService {
  constructor() {
    super();
  }

  public getType(): PHOENIX_CONTEXTS {
    return PHOENIX_CONTEXTS.NONE;
  }
}
